export default "__VITE_ASSET__ypR604Ei__"